import { render, staticRenderFns } from "./anularAutorizar.vue?vue&type=template&id=2c075731&"
import script from "./anularAutorizar.vue?vue&type=script&lang=js&"
export * from "./anularAutorizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports